export default __webpack_public_path__ + "static/media/franco.3c8e818f.jfif";